export default "__VITE_ASSET__42942b01__"